import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import { RedesignFooter, RedesignHeader, RedesignPage } from './RedesignShell';

const taskItems = [
  'создать продающий лендинг под ключ',
  'упаковать онлайн-курс и донести ценность продукта',
  'разработать структуру одностраничного сайта',
  'внедрить формы обратной связи и оплату',
  'подготовить лендинг под рекламу',
  'получать заявки и продажи',
];

const solutionBlocks = [
  {
    title: 'Разработка лендинга онлайн-курса с нуля',
    intro: 'Создан одностраничный сайт с продуманной структурой:',
    points: [
      'главный экран с оффером и кнопкой действия',
      'описание программы тренировок',
      'блоки с преимуществами курса',
      'результаты учеников (до/после)',
      'отзывы клиентов',
      'тарифы и варианты участия',
      'форма заявки и оплаты',
      'ответы на частые вопросы',
      'адаптивная мобильная версия',
    ],
    note: 'Сайт сразу проектировался под поведение пользователей: время до первого действия сократилось на 47%, а глубина просмотра выросла на 62%.',
  },
  {
    title: 'Разработка индивидуальной структуры и логики лендинга',
    intro: 'Разработана структура с учетом целевой аудитории. Это позволило:',
    points: [
      'увеличить конверсию страницы с 2,1% до 6,8%',
      'сократить путь пользователя до заявки на 35%',
      'повысить вовлеченность пользователей на 54%',
      'снизить показатель отказов с 48% до 22%',
    ],
    note: 'Лендинг стал не просто страницей, а полноценной воронкой продаж.',
  },
  {
    title: 'SEO-оптимизация лендинга онлайн-курса',
    intro: 'SEO выполнялось на этапе разработки лендинга:',
    points: [
      'сбор семантического ядра (онлайн тренировки, фитнес курс, тренировки дома и др.)',
      'формирование структуры страницы',
      'оптимизация заголовков и текстов',
      'настройка технического SEO',
      'оптимизация скорости загрузки',
    ],
    resultLabel: 'Результат:',
    resultPoints: [
      'рост органического трафика на 210% за 2 месяца',
      'выход в ТОП-10 по 60% ключевых запросов',
      'увеличение времени на сайте до 2:40',
    ],
  },
  {
    title: 'Запуск и продвижение',
    intro: 'После запуска лендинга началась работа с привлечением клиентов:',
    points: [
      'подключение аналитики (Яндекс Метрика, Google)',
      'запуск рекламы в Яндекс Директ',
      'тестирование гипотез',
      'оптимизация рекламных кампаний',
    ],
    resultLabel: 'Результат:',
    resultPoints: [
      'стоимость заявки снижена на 38%',
      'CTR объявлений вырос до 9,7%',
      'первые продажи получены в течение 24 часов',
      'окупаемость рекламы достигнута за 7 дней',
    ],
  },
];

const resultCards = [
  {
    title: 'SEO и органический трафик',
    points: [
      'рост позиций по ключевым запросам (онлайн тренировки, фитнес дома — ТОП-3)',
      'увеличение органического трафика на 320%',
      'рост количества новых пользователей на 270%',
    ],
  },
  {
    title: 'Контекстная реклама',
    points: [
      'стабильный поток целевых посетителей',
      'средняя стоимость клика — 27 ₽',
      'снижение стоимости лида с 920 ₽ до 570 ₽',
      'увеличение количества заявок в 2,3 раза',
    ],
  },
  {
    title: 'Конверсии и заявки',
    points: [
      'рост конверсии лендинга с 2,1% до 6,8%',
      'увеличение количества заявок на 185%',
      'рост продаж курса на 172%',
      'лендинг стал основным каналом привлечения клиентов (до 78% всех заявок)',
    ],
  },
];

const clientGains = [
  'продающий лендинг под ключ',
  'проработанную структуру и дизайн',
  'SEO-оптимизированную страницу',
  'настроенную рекламу',
  'систему привлечения и обработки заявок',
];

function FitnessCourseLandingCasePage() {
  return (
    <RedesignPage>
      {/* TODO(brand-redesign): получить утверждённые Title и Description; текущие provisional-значения не подтверждены исходным ТЗ. */}
      <PageMeta
        title="Разработка лендинга онлайн-курса по тренировкам | Кейс Fatality"
        description="Кейс Fatality: лендинг онлайн-курса по тренировкам под ключ, структура, дизайн, SEO, реклама, рост трафика на 320% и продаж курса на 185%."
      />
      <RedesignHeader />

      <section className="ink case-detail-hero">
        <div
          className="glow"
          style={{ right: '-340px', top: '-320px', width: '940px', height: '940px', opacity: 0.1 }}
        />
        <div className="container">
          <h1>Разработка лендинга онлайн-курса по тренировкам под ключ</h1>
          <p className="hero-sub">
            Разработка лендинга онлайн-курса по тренировкам под ключ.
          </p>
          <p className="hero-sub">
            Проект включал полный цикл: создание одностраничного сайта,
            разработку структуры, дизайн, SEO-оптимизацию и запуск рекламы.
          </p>
          <p className="hero-sub">
            Результат: рост трафика на 320%, увеличение продаж курса на 185% и
            стабильный поток заявок через лендинг уже в первый месяц.
          </p>
          <img className="case-cover-image" src="/images/cases/meditation-platform.webp" srcSet="/images/cases/meditation-platform-840.webp 840w, /images/cases/meditation-platform-1280.webp 1280w, /images/cases/meditation-platform.webp 1672w" sizes="(max-width: 1280px) calc(100vw - 40px), 1184px" alt="Платформа для медитаций — сайт и приложение" width="1672" height="941" loading="lazy" />
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container case-two-col">
          <div>
            <h2 className="standalone-h2">Задача проекта</h2>
          </div>
          <div className="case-rich-text">
            <p>
              Клиент — онлайн-школа тренировок — обратился за разработкой
              лендинга под запуск нового продукта.
            </p>
            <p>Основные задачи:</p>
            <ul>
              {taskItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p>
              Важно: нужен был не просто лендинг, а инструмент продаж, который
              будет привлекать клиентов и окупать вложения в рекламу.
            </p>
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <div className="sec-head ink-head">
            <div>
              <h2>Решение</h2>
            </div>
            <p className="sub">
              Проект реализован с учетом особенностей онлайн-образования и
              рынка фитнес-курсов.
            </p>
          </div>
          <div className="solution-grid">
            {solutionBlocks.map((block) => (
              <article className="solution-card" key={block.title}>
                <h3>{block.title}</h3>
                <p>{block.intro}</p>
                <ul>
                  {block.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
                {block.resultLabel ? <p>{block.resultLabel}</p> : null}
                {block.resultPoints ? (
                  <ul>
                    {block.resultPoints.map((point) => (
                      <li key={point}>{point}</li>
                    ))}
                  </ul>
                ) : null}
                {block.note ? <p>{block.note}</p> : null}
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <div className="sec-head">
            <div>
              <h2>Результаты проекта</h2>
            </div>
            <p className="sub">
              Проект показал рост по ключевым показателям онлайн-курса.
            </p>
          </div>
          <div className="result-grid">
            {resultCards.map((result) => (
              <div className="compact-card" key={result.title}>
                <h3>{result.title}</h3>
                <ul className="source-list">
                  {result.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <p className="service-hero-copy" style={{ color: '#141619' }}>
            В результате онлайн-курс начал получать стабильный поток продаж через сайт.
          </p>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container case-two-col">
          <div>
            <h2 className="standalone-h2 light">Что получил клиент</h2>
          </div>
          <div className="case-rich-text dark">
            <p>
              В рамках проекта клиент получил не просто разработку лендинга, а готовую систему продаж:
            </p>
            <ul>
              {clientGains.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p>Лендинг стал основным инструментом маркетинга онлайн-школы.</p>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container case-two-col">
          <div>
            <h2 className="standalone-h2">Почему этот кейс важен</h2>
          </div>
          <div className="case-rich-text">
            <p>Этот проект показывает, что разработка лендинга — это не только дизайн.</p>
            <p>Ключевую роль играет комплексный подход:</p>
            <ul>
              <li>аналитика и стратегия</li>
              <li>разработка структуры</li>
              <li>дизайн</li>
              <li>SEO-оптимизация</li>
              <li>реклама и аналитика</li>
            </ul>
            <p>Только в таком формате лендинг начинает приносить реальные продажи и окупаться.</p>
          </div>
        </div>
      </section>

      <section className="ink lead" id="fitness-course-case-lead">
        <div
          className="glow"
          style={{ left: '-300px', top: '-200px', width: '700px', height: '700px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="lead-grid">
            <div className="lead-side">
              <h2 className="lead-heading">Хотите такой же результат?</h2>
              <p className="lead-text">
                Разработка лендинга для онлайн-курса — это инвестиция в стабильный поток клиентов и рост продаж.
              </p>
              <p className="lead-text">
                Оставьте заявку — разберем ваш проект, покажем точки роста и рассчитаем стоимость разработки лендинга.
              </p>
            </div>
            <LeadForm
              formId="fitness-course-case-lead-form"
              idPrefix="fitness-case"
              eyebrow="Форма заявки"
            />
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default FitnessCourseLandingCasePage;
